export default "__VITE_ASSET__CyQ8NWOE__"